import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getCountries(data?): Observable<any> {
    return this.httpClient.get(Config.api + Config.endpoints.countries);
  }
  getCities(id): Observable<any> {
    return this.httpClient.get(Config.api + Config.endpoints.countries + id + '/cities');
  }

}
